/** Tenant feature keys read from `userData['feature-allowed']` (flattened from tenant `features`). */
export const TENANT_FEATURE_XTCE = 'xtce';

type UserDataWithFeatures = { 'feature-allowed'?: Record<string, string> } | null | undefined;

/** True only when the tenant's feature is explicitly 'Yes'; missing or loading counts as off. */
export const isTenantFeatureEnabled = (userData: UserDataWithFeatures, feature: string): boolean =>
  userData?.['feature-allowed']?.[feature] === 'Yes';

/** True once tenant features have been loaded, so "off" can be told apart from "not loaded yet". */
export const areTenantFeaturesLoaded = (userData: UserDataWithFeatures): boolean =>
  !!userData?.['feature-allowed'];

/** A deep link to the XTCE tab must fall back once features are known and xtce is not enabled. */
export const shouldLeaveXtceTab = (tabName: string | undefined, userData: UserDataWithFeatures): boolean =>
  tabName === 'XTCE' &&
  areTenantFeaturesLoaded(userData) &&
  !isTenantFeatureEnabled(userData, TENANT_FEATURE_XTCE);
